import GeometryCollection from 'ol/geom/GeometryCollection';
import Polygon, { fromCircle } from 'ol/geom/Polygon';
import { LineString, Circle } from 'ol/geom';

function coldGeometryBuilder([x, y], size) {
  const triangleCoordinates = [[x - size, y], [x + size, y], [x, y + size * 2]];
  return new Polygon([triangleCoordinates]);
}

function warmGeometryBuilder(center, size) {
  const circle = new Circle(center, size);
  const numberOfPoints = 32;
  const c = fromCircle(circle, numberOfPoints);
  const n = numberOfPoints / 2 + 1;
  const coordinates = c.getCoordinates().slice(0, n).map(m => m.slice(0, n));
  return new Polygon(coordinates);
}

function occludedGeometryBuilder([x, y], size) {
  return new GeometryCollection([coldGeometryBuilder.call(null, [x - size, y], size), warmGeometryBuilder.call(null, [x + size, y], size)]);
}

const frontBuilders = {
  Warm: warmGeometryBuilder,
  Cold: coldGeometryBuilder,
  Occluded: occludedGeometryBuilder
};
export default (({
  sizeFactor
}) => (feature, resolution) => {
  const size = resolution * sizeFactor;
  const props = feature.getProperties();
  const geometry = feature.getGeometry();
  const coordinates = geometry.getCoordinates();
  const {
    FrontType: frontType
  } = props;
  const direction = Math.PI; // frontType === 'Warm' ? 0 : Math.PI;

  const geometryBuilder = frontBuilders[frontType];
  const space = 8;
  const symbols = [];
  let l = 0;

  if (typeof geometryBuilder === 'function') {
    for (let i = 0; i < coordinates.length - 1; i += 1) {
      const line = coordinates.slice(i, i + 2);
      const [x1, y1] = line[0];
      const [x2, y2] = line[1];
      const dx = x2 - x1;
      const dy = y2 - y1;
      const lineLength = Math.hypot(dx, dy);
      const sizeWithSpace = space * size;
      l += lineLength;
      let countPerLine = lineLength / sizeWithSpace;

      if (countPerLine < 1) {
        countPerLine = l / (sizeWithSpace / 2);
      }

      if (l / (sizeWithSpace / 2) >= 1) {
        l = 0;
      }

      const count = Math.floor(countPerLine) + 1;
      const lineDir = Math.atan2(line[1][1] - line[0][1], line[1][0] - line[0][0]);
      const lineAngle = Math.atan(dy / dx) + direction;
      const angle = Math.abs(lineDir) > Math.PI / 2 ? Math.PI + lineAngle : lineAngle;

      for (let j = 1; j < count; j += 1) {
        const x = dx / count * j + x1;
        const y = dy / count * j + y1;
        const symbol = geometryBuilder([x, y], size);
        symbol.rotate(angle, [x, y]);
        symbols.push(symbol);
      }
    }
  }

  return new GeometryCollection([new LineString(coordinates), ...symbols]);
});